// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {State} from './State';

const _associations = [
			{
				name: 'State',
				model: new State(),
				type: 'ParentPointer',
				using: 'stateId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'State',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'speciesListId',
				placeholder: null,
				key: 'speciesListId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesListId,
				setter: (x, y) => x.speciesListId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'List Type',
				placeholder: null,
				key: 'speciesListTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: ["skips_data_segmentation","authenticated_user"]
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'can_alter_global_species_list',
				group: 'General',
				groupTitle: 'General',
				displayOrder: 2,
				getter: (x) => x.speciesListTypeId,
				setter: (x, y) => x.speciesListTypeId = y,
				defaultValue: 4,
				editor: 'SpeciesListTypeFieldViewer',
				viewer: 'SpeciesListTypeFieldViewer',
				validators: [
					new NumericValidator(),
					new RequiredValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Name of list',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 1,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Description',
				placeholder: 'e.g. This list is used by our program in Eastern Oregon.',
				key: 'description',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'For what purpose was this custom species list created?',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 5,
				getter: (x) => x.description,
				setter: (x, y) => x.description = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Define \'Noxious,\' \'Target,\' and \'Invasive\'',
				placeholder: 'e.g. \'Noxious\' species are those defined by 2022 Oregon Department of Agriculture. \'Invasive\' species are those that are designated by Willamette Partnership. \'Target\' are designated by project managers as important to note, but they do not count towards performance standards.',
				key: 'targetDescription',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Define \'Noxious,\' \'Target,\' and \'Invasive\' for this list.',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 6,
				getter: (x) => x.targetDescription,
				setter: (x, y) => x.targetDescription = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Other Notes',
				placeholder: 'e.g. Originally compiled by Henry, this list is now maintained by Mavis.',
				key: 'notes',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 6,
				getter: (x) => x.notes,
				setter: (x, y) => x.notes = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'State',
				placeholder: null,
				key: 'stateId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'to_number(speciesListTypeId) != `2`',
					requiresPermission: ["skips_data_segmentation","authenticated_user"]
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 3,
				getter: (x) => x.stateId,
				setter: (x, y) => x.stateId = y,
				defaultValue: null,
				editor: 'StateFieldEditor',
				viewer: 'StateFieldViewer',
				validators: [
					new NumericValidator(),
					new RequiredValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Organization (Optional)',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: ["skips_data_segmentation","authenticated_user"]
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: ["skips_data_segmentation","authenticated_user"],
				group: 'General',
				groupTitle: 'General',
				displayOrder: 4,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'OrganizationFieldEditor',
				viewer: 'OrganizationFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Last Reviewed',
				placeholder: null,
				key: 'reviewed',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'History',
				groupTitle: 'History',
				displayOrder: 14,
				getter: (x) => x.reviewed,
				setter: (x, y) => x.reviewed = y,
				defaultValue: null,
				editor: 'DateTimeFieldViewer',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Last Reviewed By',
				placeholder: null,
				key: 'reviewedByUserId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'History',
				groupTitle: 'History',
				displayOrder: 15,
				getter: (x) => x.reviewedByUserId,
				setter: (x, y) => x.reviewedByUserId = y,
				defaultValue: null,
				editor: 'UserFieldViewer',
				viewer: 'UserFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'NO_ONE_HAS_THIS_PERMISSION',
				group: 'History',
				groupTitle: 'History',
				displayOrder: 10,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateTimeFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Created By',
				placeholder: null,
				key: 'createdByUserId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'History',
				groupTitle: 'History',
				displayOrder: 11,
				getter: (x) => x.createdByUserId,
				setter: (x, y) => x.createdByUserId = y,
				defaultValue: null,
				editor: 'UserFieldViewer',
				viewer: 'UserFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Last Modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'NO_ONE_HAS_THIS_PERMISSION',
				group: 'History',
				groupTitle: 'History',
				displayOrder: 12,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Last Modified By',
				placeholder: null,
				key: 'modifiedByUserId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'History',
				groupTitle: 'History',
				displayOrder: 13,
				getter: (x) => x.modifiedByUserId,
				setter: (x, y) => x.modifiedByUserId = y,
				defaultValue: null,
				editor: 'UserFieldViewer',
				viewer: 'UserFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deletedByUserId',
				placeholder: null,
				key: 'deletedByUserId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedByUserId,
				setter: (x, y) => x.deletedByUserId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Mark As Reviewed',
				placeholder: null,
				key: 'markAsReviewed',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
					requiresPermission: 'can_update_species_list'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Check this box and click \'Save\' to update the \'Last Reviewed\' and \'Last Reviewed By\' fields.',
				requiresPermission: 'can_update_species_list',
				group: 'History',
				groupTitle: 'History',
				displayOrder: 16,
				getter: (x) => x.markAsReviewed,
				setter: (x, y) => x.markAsReviewed = y,
				defaultValue: null,
				editor: 'BooleanEditor',
				viewer: 'BooleanViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Projects that use this list',
				placeholder: null,
				key: '_assignedProjectContextNodeIds',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					query: 'speciesListId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 5,
				getter: (x) => x._assignedProjectContextNodeIds,
				setter: (x, y) => x._assignedProjectContextNodeIds = y,
				defaultValue: null,
				editor: 'ContextNodesFieldViewer',
				viewer: 'ContextNodesFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class SpeciesList extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
